module.exports = __webpack_public_path__ + "824e38fe4c3510dd48c2a644019e3cd6.svg";